<template>
  <CRow>
    <CCol col="12" lg="8">
      <CCard>
        <CCardHeader>
          <strong>Υπεργολάβος:</strong> {{ title }}
        </CCardHeader>
        <CCardBody>
          <CDataTable 
            striped 
            small 
            fixed
            :items="items" 
            :fields="fields"
          >
            <template slot="value" slot-scope="data">
              <td><strong>{{data.item.value}}</strong></td>
            </template>
          </CDataTable>
        </CCardBody>
        <CCardFooter>
          <CButton color="primary" @click="goBack">Πίσω</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'Subcontractor',
  data: () => {
    return {
      items: [],
      title: '',
      fields: [
        {key: 'key', label: 'Πεδίο'},
        {key: 'value', label: 'Τιμή'},
      ],
    }
  },
  methods: {
    getSubcontractorData (id) {
      const subcontractor = subcontractorsData.find((subcontractor, index) => index + 1 == id)
      const subcontractorDetails = subcontractor ? Object.entries(subcontractor) : [['id', 'Not found']]
      return subcontractorDetails.map(([key, value]) => { return { key, value } })
    },
    goBack() {
      this.$router.go(-1)
    }
  },
  mounted: function(){
    let self = this;
    axios.get('/api/subcontractors/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      //const items = response.data.subcontractors;
      const ser_items = Object.entries(response.data.subcontractor).map(([key, value]) => {return {key: key, value: value}});
      const keys = ["name", "activity"];
      self.items = ser_items.filter((t) => keys.includes(t.key));
      self.title = self.items.find((t) => t.key == "name").value;

      const items = Object.entries(response.data.subcontractor);
      self.items = items.map(([key, value]) => {return {key: key, value: value}});

      self.items = self.items.map((item) => {
         if (item.key == "id") {
            item.key = "ID:";
        } else if (item.key == "name") {
            item.key = "Ονοματεπώνυμο:";
        } else if (item.key == "created_at") {
            item.value = moment(new Date(item.value)).format('DD-MM-YYYY');
            item.key = "Καταχωρήθηκε στις:";
        } else if (item.key == "updated_at") {
            item.value = moment(new Date(item.value)).format('DD-MM-YYYY');
            item.key = "Ενημερώθηκε στις:";
        } else if (item.key == "activity") {
            item.key = "Δραστηριότητα:";
        } else if (item.key == "afm") {
            item.key = "ΑΦΜ:";
        } else if (item.key == "doy") {
            item.key = "ΔΟΥ:";
        } else if (item.key == "profession") {
            item.key = "Επάγγελμα:";
        } else if (item.key == "tk") {
            item.key = "Ταχυδρομικός Κώδικας:";
        } else if (item.key == "notes") {
            item.key = "Άλλες Πληροφορίες / Σχόλια:";
        } else if (item.key == "phone") {
            item.key = "Τηλέφωνο:";
        } else if (item.key == "email") {
            item.key = "Email:";
        }  

        return item;
      });
    }).catch(function (error) {
      console.log(error);
      self.$router.push({ path: '/login' });
    });
  }
}
</script>